import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
const testimonials = [{
  quote: "Offsite+ transformed how we pitch group business. We're no longer just selling rooms and F&B; we're selling a guaranteed, measurable outcome. Our close rate on corporate retreats is up 40%.",
  name: 'Sarah Jenkins',
  title: 'VP Group Sales',
  company: 'Luxury Resort Collection',
  initials: 'SJ',
  color: 'bg-brand-teal text-white'
}, {
  quote: 'The AI Designer saves my team hours of manual work. We used to spend days building proposals and agendas in spreadsheets. Now we generate a branded, world-class experience in minutes.',
  name: 'Marcus Chen',
  title: 'Founder & CEO',
  company: 'Elevate DMCs',
  initials: 'MC',
  color: 'bg-brand-coral text-white'
}, {
  quote: 'Finally, a way to measure the ROI of our leadership offsites. The post-event reporting gives me the exact data I need to show the board how these events impact our culture and alignment.',
  name: 'Elena Rodriguez',
  title: 'Chief People Officer',
  company: 'TechForward Inc.',
  initials: 'ER',
  color: 'bg-brand-navy text-white'
}, {
  quote: 'Being able to license frameworks from top business schools directly into my workshops has elevated my practice. My clients love the app, and I look like a rockstar.',
  name: 'David Thompson',
  title: 'Independent Facilitator',
  company: 'Thompson Leadership',
  initials: 'DT',
  color: 'bg-amber-500 text-white'
}];
const logos = ['Cedarwood Group', 'Meridian Health', 'Brightwater Capital', 'Halcyon Partners', 'Vantage Logistics'];
export function SocialProof() {
  return <section className="py-24 px-6 md:px-10 bg-slate-50 border-y border-slate-100" data-id="element-6743">
      <div className="max-w-7xl mx-auto" data-id="element-6744">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-6745">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-6746">
            <h2 className="text-3xl md:text-5xl font-bold text-brand-navy mb-6 tracking-tight" data-id="element-6747">
              Trusted by teams who design{' '}
              <span className="text-brand-coral" data-id="element-6748">unforgettable events</span>
            </h2>
            <div className="flex items-center justify-center gap-1 mb-4" data-id="element-6749">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-6750" />)}
            </div>
            <p className="text-lg text-slate-600" data-id="element-6751">
              Join hundreds of hotels, planners, and HR leaders using Offsite+
              to deliver better experiences.
            </p>
          </motion.div>
        </div>

        {/* Logo Cloud */}
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 mb-16 opacity-50 grayscale" data-id="element-6752">
          {logos.map((logo, i) => <motion.div key={logo} initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="text-xl md:text-2xl font-bold font-serif text-slate-400" data-id="element-6753">
              {logo}
            </motion.div>)}
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto" data-id="element-6754">
          {testimonials.map((t, i) => <motion.div key={t.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1,
          duration: 0.5
        }} className="bg-white rounded-2xl p-8 shadow-soft border border-slate-100 relative" data-id="element-6755">
              <QuoteIcon className="absolute top-8 right-8 w-10 h-10 text-slate-100 rotate-180" data-id="element-6756" />
              <p className="text-lg text-slate-700 leading-relaxed mb-8 relative z-10" data-id="element-6757">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-6758">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg ${t.color}`} data-id="element-6759">
                  {t.initials}
                </div>
                <div data-id="element-6760">
                  <div className="font-bold text-brand-navy" data-id="element-6761">{t.name}</div>
                  <div className="text-sm text-slate-500" data-id="element-6762">
                    {t.title}, {t.company}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}